/* eslint-disable implicit-arrow-linebreak */
import { homologaNumeroPedimento } from "../../common/pedimentos/utils";
import { DescargaCommonGlobal } from "./descarga.global";

/**
 * Filtra los contenedores donde el material a descargar coincide con el material
 * de la importación
 * @param {string} materialExpo
 * @param {string} materialImpo
 * @returns
 */
const filterMaterial = (materialExpo, materialImpo) => materialExpo === materialImpo;

/**
 * Filtra los contenedores de importación donde su fecha pago sea anterior a la fecha pago
 * de la exportacion.
 *
 * Nota: la fechaImportacion del pedimento de impo, proviene de la api, la api dedice el tipo de
 * la fecha dependiendo de los filtros de busqueda
 * @param {Date} fechaPagoExportacion
 * @param {Date} fechaImportacion
 * @returns
 */
const filterFechaPago = (fechaPagoExportacion, fechaImportacion) => fechaImportacion <= fechaPagoExportacion;

/**
 * Filtra los pedimentos de importación vigentes, validando la fecha de vencimiento de
 * la importación contra la fecha pago de la exportación
 * @param {Date} fechaVencimientoImportacion
 * @param {Date} fechaPagoExportacion
 * @returns
 */
const filterImportacionesVigentes = (fechaPagoExportacion, fechaVencimientoImportacion) => {
    if (fechaVencimientoImportacion && fechaVencimientoImportacion < fechaPagoExportacion) {
        return false;
    }
    return true;
};

/**
 * Filtra los contenedores de importación que son de desperdicio, validando de acuerdo
 * a la clave de documento del pedimento de exportación
 * @param {string} claveDocumento 
 * @param {boolean} isDesperdicio 
 * @returns 
 */
const filterContenedoresDesperdicio = (claveDocumento, isDesperdicio) => {
    if (!["F4", "RT", "DES", "F5", "A3"].includes(claveDocumento) && isDesperdicio) {
        return false;
    }
    return true;
};

/**
 * Construye la data para la DataTableDescarga
 * @param {Object} contenedor Contenedor de importación
 * @returns
 */
const makeDataToDataTable = ({
    fecha_pago,
    seccion,
    patente,
    pedimento,
    material,
    contenedor_id,
    cantidad,
    clave_documento,
    isDesperdicio,
}) => ({
    pedimento: homologaNumeroPedimento({
        fechaPagoReal: fecha_pago,
        seccion,
        patente,
        pedimento,
        isDesperdicio,
    }),
    material,
    contenedor_id,
    cantidad,
    cantidad_utilizar: cantidad,
    fecha_pago,
    clave_documento,
    isDesperdicio,
});

/**
 * Obtenie los contenedores de importación validando el material y la fecha de pago de la exportación.
 * @param {string} material Material de exportación
 * @param {string} fechaPago Fecha pago de la exportación
 * @param {string} claveDocumento Clave documento del pedimento de exportación
 */
export const obtenerContenedoresImportacionValidos = (material, fechaPago, claveDocumento) =>
    DescargaCommonGlobal.contenedoresImportacionParaDescargar
        .filter((contenedor) => filterMaterial(material, contenedor.material))
        .filter((contenedor) => filterFechaPago(fechaPago, contenedor.fecha_pago))
        .filter(
            (contenedor) =>
                claveDocumento === "A3" || filterImportacionesVigentes(fechaPago, contenedor.fecha_vencimiento),
        )
        .filter((contenedor) => filterContenedoresDesperdicio(claveDocumento, contenedor.isDesperdicio))
        .map(makeDataToDataTable);
